import { createIsFetchingReducer } from '../../helpers/reducers';
import { types } from '../../actions/events';

const initialState = true;

const apiActionTypes = [
  types.EVENTS_SHOW,
  types.EVENTS_LATEST,
  types.EVENTS_TICKETS,
  types.EVENTS_TICKETS_CURATED,
];

const isFetching = createIsFetchingReducer(initialState, apiActionTypes);

export default isFetching;

export const getIsFetching = state => state.events.isFetching;



// WEBPACK FOOTER //
// ./src/reducers/events/isFetching.js